import { patchCompany } from "../../cs_edit";

type CustomersNumberInlineEditConfig = {
  selector: string;
  eventNamespace: string;
  payloadField: string;
  parseErrorMessage: string;
};

export function initCustomersNumberInlineEdit(
  config: CustomersNumberInlineEditConfig,
) {
  $(config.selector)
    .off(config.eventNamespace)
    .on(config.eventNamespace, function (e) {
      e.stopPropagation();
      if ($(this).find(".inline-edit-input").length) return;

      const currentValue = $(this).attr("data-sort-value") || "";
      const id = $(this).closest(".customer-row").attr("data-id");
      const csDatumId = $(this)
        .closest(".customer-row")
        .attr("data-cs-datum-id");
      if (!id) return;

      const originalHTML = $(this).html();

      const input = document.createElement("input");
      input.type = "number";
      input.value = currentValue;
      input.className = "inline-edit-input";

      $(this).text("");
      $(this).addClass("is-editing");
      $(this).append(input);
      input.focus();
      input.select();

      let saved = false;
      const cell = this as HTMLElement;

      const save = () => {
        if (saved) return;
        saved = true;

        const newValue = input.value.trim();
        if (newValue === currentValue) {
          cancel();
          return;
        }

        if (isNaN(Number(newValue))) {
          alert("Please enter a valid number.");
          cancel();
          return;
        }

        $(cell).removeClass("is-editing");
        $(cell).text("Saving...");
        $(cell).addClass("inline-edit-saving");

        const csDatumAttributes: { [key: string]: string } = {};
        csDatumAttributes[config.payloadField] = newValue;

        if (csDatumId) {
          csDatumAttributes.id = csDatumId;
        }

        patchCompany(
          id,
          { cs_datum_attributes: csDatumAttributes },
          cell,
          originalHTML,
        );
      };

      const cancel = () => {
        $(this).text(currentValue)
        input.remove()
        saved = true;
        $(cell).removeClass("is-editing");
        $(cell).html(originalHTML);
      };

      input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          save();
        } else if (event.key === "Escape") {
          event.preventDefault();
          cancel();
        }
      });

      input.onblur = cancel;
    });
}
